<template>
  <div class="mars-ape-layout-header">
    <div class="header-left">
      <i class="iconfont header-index-trigger" :class="[isCollapse?'icon-menu-fold':'icon-menu-unfold']" @click="handleClick"></i>
    </div>
    <div class="header-middle">

    </div>
    <div class="header-right">
      <!-- 需求2：通知中心铃铛（未读数轮询） -->
      <el-popover placement="bottom-end" width="360" trigger="click" @show="loadNoticeList">
        <div class="notice-panel">
          <div class="notice-panel-header">
            <span>通知中心</span>
            <el-button type="text" size="mini" @click="markAllRead">全部已读</el-button>
          </div>
          <div class="notice-panel-list" v-loading="noticeLoading">
            <div v-if="noticeList.length === 0 && !noticeLoading" class="notice-empty">暂无通知</div>
            <div v-for="item in noticeList" :key="item.id" class="notice-item" :class="{'is-unread': item.is_read === '0'}" @click="readOne(item)">
              <div class="notice-item-title">
                <span class="notice-dot" v-if="item.is_read === '0'"></span>{{ item.title }}
              </div>
              <div class="notice-item-content">{{ item.content }}</div>
              <div class="notice-item-time">{{ item.notify_time }}</div>
            </div>
          </div>
          <div class="notice-panel-footer">
            <el-button type="text" size="mini" @click="goNotificationCenter">查看全部</el-button>
          </div>
        </div>
        <el-badge slot="reference" :value="unreadCount" :hidden="unreadCount === 0" :max="99" class="item">
          <i class="iconfont icon-lingdang"></i>
        </el-badge>
      </el-popover>
      <el-tooltip content="扫码下载管理 App" placement="bottom">
        <button type="button" class="header-app-btn" @click="handleDownloadApp">
          <i class="el-icon-mobile-phone"></i>
          <span>App</span>
        </button>
      </el-tooltip>
      <el-dropdown @command="handleCommand">
        <span class="right-account">
          <span class="right-account-avatar">
            <img src="@/assets/avatar.png" alt="avatar">
          </span>
          <span class="right-account-name">{{userInfo['nickname']}}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item  command="setting"><i class="iconfont icon-touxiang"></i><span>个人设置</span></el-dropdown-item>
          <el-dropdown-item command="app"><i class="el-icon-mobile-phone"></i><span>App 安装包</span></el-dropdown-item>
          <el-dropdown-item divided command="logout"><i class="iconfont icon-tuichudenglu2"></i><span>退出登录</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'

export default {
  data() {
    return {
      unreadCount: 0,
      noticeList: [],
      noticeLoading: false,
      noticeTimer: null
    }
  },
  methods: {
    ...mapMutations([
      'handleUserInfo'
    ]),
    // 需求2：未读数轮询（30秒）
    async loadUnreadCount() {
      try {
        const res = await this.$api.post('/service/notification/unread_count')
        if (res && res.code === 200) {
          const n = res.data && res.data.unread_count
          this.unreadCount = parseInt(n, 10) || 0
        }
      } catch (e) { /* 静默 */ }
    },
    async loadNoticeList() {
      this.noticeLoading = true
      try {
        const res = await this.$api.post('/service/notification/list', { page: 1, page_size: 8 })
        if (res && res.code === 200 && res.data) {
          this.noticeList = (res.data.list || []).slice(0, 8)
        }
      } catch (e) { /* 静默 */ }
      this.noticeLoading = false
    },
    async markAllRead() {
      try {
        await this.$api.post('/service/notification/mark_read', { ids: [] })
        this.loadUnreadCount()
        this.loadNoticeList()
      } catch (e) { /* 静默 */ }
    },
    async readOne(item) {
      if (item.is_read === '0') {
        try {
          await this.$api.post('/service/notification/mark_read', { ids: [item.id] })
          item.is_read = '1'
          this.loadUnreadCount()
        } catch (e) { /* 静默 */ }
      }
    },
    goNotificationCenter() {
      this.$router.push('/system/notification')
    },
    // 左侧菜单的展开折叠
    handleClick () {
      this.$store.commit('changeCollapse')
    },
    // 处理下拉菜单指令
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      }
      if (command === 'setting') {
        this.handleSetting()
      }
      if (command === 'app') {
        this.handleDownloadApp()
      }
    },
    handleDownloadApp() {
      this.$router.push('/app/package')
    },
    // 处理退出
    async handleLogout() {
        this.$api.post('/service/user/logout')
        localStorage.removeItem('user_info')
        this.$message.success('退出成功！')
        this.$router.push('/login')
    },
    async handleSetting() {
        this.$router.push('/customer/profile')
    }
  },
  computed: {
    ...mapGetters(['isCollapse','userInfo'])
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('user_info'))
    this.handleUserInfo(userInfo)
    // 需求2：通知铃铛未读数轮询
    this.loadUnreadCount()
    this.noticeTimer = setInterval(this.loadUnreadCount, 30000)
  },
  beforeDestroy() {
    if (this.noticeTimer) {
      clearInterval(this.noticeTimer)
      this.noticeTimer = null
    }
  },
}
</script>

<style lang="stylus" scoped>
.mars-ape-layout-header .iconfont 
  display inline-block
  box-sizing border-box
  font-size 24px
.mars-ape-layout-header 
  height 64px
  background #fff
  box-shadow 0 1px 4px rgba(0,21,41,.08)
  position relative
  overflow hidden
.mars-ape-layout-header>.header-left,.mars-ape-layout-header>.header-middle 
  float left
  color #595959
.mars-ape-layout-header>.header-right 
  float right
  line-height 64px
  overflow hidden
.header-app-btn
  display inline-flex
  align-items center
  gap 4px
  height 32px
  margin 16px 8px 16px 0
  padding 0 12px
  border 1px solid #dcdfe6
  border-radius 16px
  background #fff
  color #409EFF
  cursor pointer
  font-size 13px
  vertical-align top
  transition all .2s
  i
    font-size 16px
  &:hover
    border-color #409EFF
    background #ecf5ff
.mars-ape-layout-header>.header-left>.header-index-trigger 
  font-size 20px
  height 64px
  cursor pointer
  transition all .3s,padding 0s
  padding 22px 24px
i.header-index-trigger:hover 
  background rgba(0,0,0,.025)
.header-right .right-account,.header-right .right-notice 
  padding 0 12px
  display inline-block
  transition all .3s
  cursor pointer
  color:rgba(0,0,0,.65)
.right-notice .el-badge 
  line-height 24px
.right-account-avatar>img 
  width 100%
  display block
.right-account-avatar 
  width 24px
  line-height 24px
  border-radius 50%
  display inline-block
  margin 20px 8px 20px 0
  vertical-align top
.right-account-name 
  font-size 14px
.right-notice:hover,.right-account:hover 
  background rgba(0,0,0,.025)
.notice-panel 
  max-height 420px
  display flex
  flex-direction column
.notice-panel-header 
  display flex
  justify-content space-between
  align-items center
  padding 4px 4px 10px
  border-bottom 1px solid #eee
  font-weight 600
.notice-panel-list 
  overflow-y auto
  max-height 300px
  min-height 60px
.notice-empty 
  text-align center
  color #999
  padding 28px 0
.notice-item 
  padding 10px 6px
  border-bottom 1px dashed #f0f0f0
  cursor pointer
  &:hover 
    background #fafafa
.notice-item-title 
  font-size 13px
  font-weight 600
  color #333
  display flex
  align-items center
.notice-dot 
  width 6px
  height 6px
  border-radius 50%
  background #f56c6c
  display inline-block
  margin-right 6px
.notice-item.is-unread .notice-item-title 
  color #c47f17
.notice-item-content 
  font-size 12px
  color #666
  margin 4px 0 2px
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
.notice-item-time 
  font-size 11px
  color #aaa
.notice-panel-footer 
  text-align center
  padding-top 8px
  border-top 1px solid #eee
.el-dropdown-menu__item 
  padding 5px 12px
  line-height 22px
  font-weight 400
  color rgba(0,0,0,0.65)
.el-dropdown-menu__item > .iconfont 
  margin-right 8px
.el-dropdown-menu__item > .el-icon-mobile-phone
  margin-right 8px
  font-size 16px
.el-dropdown-menu 
  padding 4px 0
  margin 0px
.el-dropdown-menu__item--divided 
  padding-top 0px
  line-height 28px
.el-dropdown-menu__item--divided::before 
  margin 0 -12px
.el-dropdown-menu.el-popper 
  min-width 160px
  top 56px !important
.el-popper .popper__arrow 
  border-width 0px
.el-popper .popper__arrow::after 
  border-width 0px
</style>